import React from 'react';
import Layout from '../components/Layout';
import {graphql} from 'gatsby';
import {GatsbyImage, getImage} from 'gatsby-plugin-image';
import Nod from '../components/nod';

const GRID = [
  [0, 1],
  [2, 3, 4],
  [5, 6],
  [7, 8, 9],
  [10, 11],
  [12, 13, 14],
];

export default function Sastreria({data: {images}}) {
  const nodes = images.nodes;

  return <Layout header={'SASTRERÍA DESESTRUCTURADA'} next={"/lookbook/"}>
    <Nod title={'SASTRERÍA DESESTRUCTURADA'}/>
    <div className="row">
      <div className="col-12 col-lg-8">
        <p className="collection-text">
          En esta colección Néstor Osuna nos presenta un tipo de Sastrería poco común pero más
          adaptada a los tiempos de hoy, una Sastrería Desestructurada y a su vez sin género.
          Desestructurar algo significa hacer perder una estructura o no tener una estructura
          definida. Sin seguir ningún tipo de protocolo, reglas o normas formales, Néstor nos propone un
          traje o un Traje de Chaqueta sin esa estructura que los hace rígidos e incomodos, dándole
          a su vez naturalidad, espontaneidad y sencillez, reconciliando la innovación con la
          tradición.
          Al dejar las técnicas tradicionales de la sastrería, cuidando la línea del hombro en los
          sacos, Néstor combina nuevos materiales y formas, obteniendo así el look perfecto.
        </p>
      </div>
    </div>

    <div className="gallery">
      {GRID.map((row, ri) => (
        <div key={ri} className="gallery-row">
          {row.map(idx => {
            const img = nodes[idx];
            if (!img) return null;
            const size = row.length === 3 ? 'gallery-item--third' : 'gallery-item--half';
            return (
              <div key={img.id} className={`gallery-item ${size}`}>
                <GatsbyImage
                  image={getImage(img)}
                  alt="Sastrería Desestructurada"
                  className="gallery-image"
                />
              </div>
            );
          })}
        </div>
      ))}
    </div>
  </Layout>;
}

export const query = graphql`{
    images: allFile(
      filter: {relativePath: {regex: "/(sd24_|sastreria)/i"}}
      sort: {order: DESC, fields: relativePath}
    ) {
      nodes {
        id
        relativePath
        childImageSharp {
          gatsbyImageData(
            layout: CONSTRAINED
            quality: 100
          )
        }
      }
    }
  }
`;
